import { Box } from "@mui/material";
import { setDay } from "date-fns";
import { useContext } from "react";
import { useFormContext } from "react-hook-form";
import {
  CheckboxField,
  TimeRangesPickerField,
} from "../../../components/Forms";
import { useMsg } from "../../../components/Msg/Msg";
import { P } from "../../../components/Typography";
import { I18nContext } from "../../I18n/I18nProvider";
import { FieldLayout } from "../FormRow";
import { WHITE_BG } from "../Settings.page";
import { INDEX_TO_DAY } from "../constants";
import { dayRangesName, enabledName } from "./AvailabilitySettings";

export const DaySlots = ({ dayName }) => {
  const msg = useMsg();
  const { i18n } = useContext(I18nContext);
  const enabled = useFormContext().watch(enabledName(dayName));
  const referenceDate = new Date();

  return (
    <FieldLayout
      label={
        <>
          <CheckboxField name={enabledName(dayName)} />
          <Box component={"span"} sx={{ textTransform: "capitalize" }}>
            {i18n.formatLocal(
              setDay(
                new Date(),
                INDEX_TO_DAY.findIndex((name) => name === dayName),
              ),
              "EEEE",
            )}
          </Box>
        </>
      }
      LabelComponent={P}
      dividerTop
      sx={{}}
    >
      <Box display="flex">
        {enabled ? (
          <TimeRangesPickerField
            name={dayRangesName(dayName)}
            inputProps={{ sx: { ...WHITE_BG, width: 140 } }}
            referenceDate={referenceDate}
          />
        ) : (
          msg("settings.availability.unavailable")
        )}
      </Box>
    </FieldLayout>
  );
};
